import React, { useMemo } from 'react'
import _ from 'lodash'
import Tracker from '../../../services/Tracker'
import getSortOptions from '../sortOptions'
import { CheckIcon } from '../icons'

// Single-select sort dropdown — applies on radio click (no Apply CTA on desktop).
// Mirrors SortBy.onFilterChanged behavior including analytics tracking.

const tracker = new Tracker()

export default function SortPanel({ model, changeState, search, onClose }) {
  const currentCode = (model.filters.sort_by && model.filters.sort_by.query && model.filters.sort_by.query.code) || ''

  const options = useMemo(() => getSortOptions(model), [model])

  function pick(code) {
    if (code === currentCode) { onClose(); return }

    const updated = _.cloneDeep(model)
    const prevCode = updated.filters.sort_by.query.code
    updated.filters.sort_by.query.code = code
    updated.filters.sort_by.on = false
    delete updated.filters.ab
    updated.filters.pagination.page = 1

    changeState(updated)
    search({ m: updated })

    const source = location.pathname.toLowerCase() === '/search' ? 'Search 2.0' : 'Home Page'
    try {
      tracker.trackSortFilterClick({ source, v1: prevCode, v2: code })
    } catch (err) {
      // Tracker failure should not block sort change.
    }

    document.dispatchEvent(new CustomEvent('update-listing-filters', {
      detail: { filters: updated.filters }
    }))
    onClose()
  }

  // DEV-2980: the storefront's sort menu rows (.fb-menu button + check).
  return (
    <>
      {options.map(([code, label]) => (
        <button
          key={code}
          type="button"
          role="menuitemradio"
          aria-checked={code === currentCode}
          className={code === currentCode ? 'is-active' : ''}
          onClick={() => pick(code)}
        >
          <span>{label}</span>
          {code === currentCode && <CheckIcon />}
        </button>
      ))}
    </>
  )
}
